module.exports = __webpack_public_path__ + "static/img/openFlower.11d4a587.jpeg";